import React, { useState } from 'react'
import { useNavigate } from "react-router-dom";


import { VerifyAccountOTP } from './tools/VerifyAccountOTP';

const VerifyAccount = () => {

  const navigate = useNavigate();

  const [stepper, setStepper] = useState(parseInt(0));

  const handleStep = (data) => {
    setStepper(parseInt(data))
  }

  return (
    <div className='h-screen w-full bg-gray-50 gap-2 flex flex-row items-center justify-center relative'>
      <VerifyAccountOTP handleStep={handleStep} />
    </div>
  )
}

export default VerifyAccount;
